<template>
  <v-breadcrumbs>
    <template v-for="(crumb, index) in crumbs">
      <router-link
          v-if="!crumb.disabled"
          :to="crumb.path"
          :key="crumb.path"
          class="breadcrumb-link"
      >
        {{ crumb.text }}
      </router-link>
      <span v-else class="text" :key="crumb.path">{{ crumb.text }}</span>
      <v-icon class="icon" v-if="index !== crumbs.length - 1" :key="'icon-' + index">mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  computed: {
    crumbs() {
      let pathArray = this.$route.path.split("/");
      let pathText = this.$route.meta.breadCrumb.split("/");
      let pathsComId = ["dadosdocronograma"];
      const isRecebiveisPagamento = this.$route.path.includes("recebiveis/pagamentos");

      if (JSON.stringify(this.$route.params) !== "{}" && !isRecebiveisPagamento) {
        pathArray.pop();
      }

      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        let id = this.$store.state.permissions.id[path];
        let pathRoute = idx > 1
            ? breadcrumbArray[idx - 1].path + "/" + path
            : "/" + path;

        breadcrumbArray.push({
          path: pathsComId.includes(path) ? pathRoute + "/" + id : pathRoute,
          text: pathText[idx] || path,
          disabled: idx === pathArray.length - 1,
        });

        return breadcrumbArray;
      }, []);

      return breadcrumbs;
    }
  }
};
</script>

<style>
.breadcrumb-link {
  text-decoration: none;
  color: inherit;
}

.breadcrumb-link:hover {
  text-decoration: none;
}

.icon {
  font-size: 16px !important;
}

.text {
  color: #979797;
}
</style>
